var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          attrs: {
            title: "新增",
            visible: _vm.dialogShow,
            "close-on-click-modal": false,
            modal: false,
            "modal-append-to-body": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            },
            close: function($event) {
              return _vm.clearData(true)
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              attrs: {
                "label-position": "left",
                rules: _vm.rules,
                model: _vm.paramsData,
                "label-width": "110px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "game", label: "游戏：" }
                },
                [
                  _c(
                    "el-select",
                    {
                      ref: "",
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择游戏"
                      },
                      model: {
                        value: _vm.paramsData.game,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "game", $$v)
                        },
                        expression: "paramsData.game"
                      }
                    },
                    _vm._l(_vm.gameAllList, function(item) {
                      return _c("el-option", {
                        key: item.game_mark,
                        attrs: { label: item.game_name, value: item.game_mark }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  staticStyle: { width: "100%" },
                  attrs: { prop: "auto_msg", label: "自定义内容：" }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: {
                      type: "textarea",
                      rows: 8,
                      placeholder: "请输入自定义内容"
                    },
                    model: {
                      value: _vm.paramsData.auto_msg,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "auto_msg", $$v)
                      },
                      expression: "paramsData.auto_msg"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "is_auto_reply", label: "自动回复：" }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      staticStyle: { "margin-left": "10px" },
                      model: {
                        value: _vm.paramsData.is_auto_reply,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "is_auto_reply", $$v)
                        },
                        expression: "paramsData.is_auto_reply"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: true, border: "" } }, [
                        _vm._v("是")
                      ]),
                      _c("el-radio", { attrs: { label: false, border: "" } }, [
                        _vm._v("否")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { round: "" },
                  on: {
                    click: function($event) {
                      _vm.dialogShow = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "" },
                  on: { click: _vm.dataFormSubmit }
                },
                [_vm._v("提交")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }